import React from 'react';
import { NotFoundPage } from '@shapeable/core';

export default (props: any) => (
  <NotFoundPage />
);

  